import { useAppStore } from '@/stores/app'
import { useFetchStore } from '@/stores/fetch'
import type { IMeResponse } from '@/types/Auth'

// loadMe fetches the current principal and populates the app store (role + project grants). Used by
// the router guard on first navigation / page reload to restore session state from a stored JWT.
export async function loadMe(): Promise<boolean> {
    const appStore = useAppStore()
    const fetchStore = useFetchStore()

    const { statusCode, data } = await fetchStore.fetch('/me').get().json<IMeResponse>()

    if (statusCode.value === 200 && data.value) {
        appStore.setUser(data.value)

        return true
    }

    return false
}
